// PR-K v2 UX — thông báo nhẹ khi server bận (rate limit / origin breaker):
// FE GIỮ dữ liệu cũ (edgeApi last-good, React Query cache) + toast thân
// thiện — KHÔNG trắng trang, KHÔNG popup lỗi kỹ thuật, KHÔNG retry ngay.
// v17.05 (08/2026) — Chỉ toast sau ≥2 lần fail liên tiếp cách nhau ≥5s để
// tránh false-positive khi origin flap 1 nhịp (Emergent rotate hostname
// đột ngột 08/03). 1 fail đơn lẻ → im lặng, edgeApi tự fallback origin.
import { toast } from "sonner";
import { isEmbedRuntime } from "./embedMode";

const NOTIFY_MIN_GAP_MS = 60_000;
const CONSECUTIVE_MIN_GAP_MS = 5_000;
const CONSECUTIVE_MAX_GAP_MS = 60_000;
let _lastNotifyAt = 0;
let _lastBusyEventAt = 0;
let _consecutiveBusyCount = 0;

export function initServerBusyNotice() {
  if (typeof window === "undefined" || isEmbedRuntime()) return;
  window.addEventListener("pl:server-busy", () => {
    const now = Date.now();
    const gap = now - _lastBusyEventAt;
    if (gap > CONSECUTIVE_MAX_GAP_MS) {
      // Chuỗi cũ đã hết hạn → reset counter.
      _consecutiveBusyCount = 1;
    } else if (gap >= CONSECUTIVE_MIN_GAP_MS) {
      _consecutiveBusyCount += 1;
    }
    // Nếu chưa >=2 lần cách nhau >=5s → im lặng.
    _lastBusyEventAt = now;
    if (_consecutiveBusyCount < 2) return;
    if (now - _lastNotifyAt < NOTIFY_MIN_GAP_MS) return;
    _lastNotifyAt = now;
    toast.info("Hệ thống đang bận", {
      description: "Đang hiển thị dữ liệu gần nhất — sẽ tự cập nhật lại trong giây lát.",
      duration: 5000,
      id: "pl-server-busy",
    });
  });
}
